// extracted by mini-css-extract-plugin
export default {"noPage":"NoPage_noPage__nOsYn"};